<mat-card class="info-card">
  <mat-card-header class="info-header">
    <div>{{ 'signin.info.title' | translate }}</div>
  </mat-card-header>
  <mat-card-actions class="info-action">
    <a mat-flat-button color="primary" class="btn" [href]="info()" target="_blank" rel="noopener noreferrer">
      {{ 'signin.info.learn' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
